import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceConfiguration } from '../../services/DeviceService';
import { DeviceConfiguration } from '../../types/Devices';

function useGetDeviceConfiguration(deviceId: string, fleetId: string): UseQueryResult<DeviceConfiguration> {
  return useQuery(
    ['device-configuration', deviceId, fleetId],
    async (): Promise<DeviceConfiguration> => getDeviceConfiguration(deviceId, fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      enabled: !!deviceId && !!fleetId,
    },
  );
}

export default useGetDeviceConfiguration;
